<template>
  <v-dialog fullscreen persistent v-model="displayed" max-width="1000px">
    <v-card>
      <v-toolbar color="primary">
        <v-card-title class="pl-0">
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
      </v-toolbar>

      <v-card-text style="height: calc(100vh - 108px); overflow: auto">
        <v-tabs
          v-if="editedIndex === -1"
          background-color="#272727"
          v-model="isNewMedia"
          class="mt-5"
        >
          <v-tab class="primary--text" :key="0">
            <v-icon class="mr-2 primary--text text-h6"
              >mdi-file-plus-outline</v-icon
            >
            New Media
          </v-tab>
          <v-tab class="primary--text" :key="1"> Select existing media </v-tab>

          <v-tab-item :key="0">
            <v-container fluid class="pl-0 pr-0">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="editedItem.name"
                    :hide-details="true"
                    label="Name"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="getMediaTypes"
                    v-model="editedItem.mediaTypeId"
                    label="Media Type"
                    item-text="label"
                    item-value="value"
                    :hide-details="true"
                    :disabled="editedIndex !== -1"
                    @change="resetOrder"
                  ></v-select>
                </v-col>
                <!-- <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="editedItem.langId"
                    label="Language ID"
                    :hide-details="true"
                  ></v-text-field>
                </v-col> -->
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="langOptions"
                    item-text="name"
                    item-value="id"
                    label="Language"
                    outlined
                    v-model="editedItem.langId"
                    :menu-props="{ top: false, offsetY: true }"
                    class="mx-0 mb-3"
                    hide-details="auto"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row
                justify="space-around"
                v-if="
                  editedItem.mediaTypeId === enums.MediaType.poi_image ||
                    editedItem.mediaTypeId ===
                      enums.MediaType.project_title_image ||
                    editedItem.mediaTypeId === enums.MediaType.poi_image_dzi ||
                    editedItem.mediaTypeId === enums.MediaType.menu_item_image
                "
              >
                <v-col cols="12" sm="12" md="12">
                  <v-tabs
                    v-if="editedIndex === -1"
                    background-color="#272727"
                    v-model="imageAssetTabActive"
                  >
                    <!-- <v-tabs-slider></v-tabs-slider> -->
                    <v-tab
                      class="primary--text"
                      :key="1"
                      :href="`#image-asset-tab-file`"
                    >
                      <v-icon class="mr-2 primary--text text-h6"
                        >mdi-file-plus-outline</v-icon
                      >
                      File
                    </v-tab>
                    <v-tab
                      class="primary--text"
                      :key="2"
                      :href="`#image-asset-tab-url`"
                    >
                      <v-icon class="mr-2 primary--text text-h6"
                        >mdi-link</v-icon
                      >
                      URL
                    </v-tab>

                    <v-tab-item :key="1" :value="'image-asset-tab-url'">
                      <v-card flat class="mx-auto pt-10">
                        <v-card-actions>
                          <v-text-field
                            v-model="editedItem.url"
                            label="URL"
                            @input="onUrlFieldChange"
                            clearable
                            @click:clear="clearUrl()"
                          ></v-text-field>
                        </v-card-actions>
                        <v-img
                          :src="imageData"
                          max-height="400"
                          contain
                          class="grey darken-4 black--text align-end"
                        ></v-img>
                      </v-card>
                    </v-tab-item>

                    <v-tab-item :key="2" :value="'image-asset-tab-file'">
                      <upload-dialog
                        :showDialog="uploadDialogVisible"
                        @done="uploadDialogOnDone"
                        @cancel="uploadDialogOnCancel"
                      ></upload-dialog>
                      <v-card flat class="mx-auto pt-5 pb-5">
                        <div
                          @drop.prevent="addFile"
                          @dragover.prevent
                          class="drop-area"
                        >
                          <span>Drop a file to upload</span>
                          <span>or</span>
                          <v-btn small @click="upload" class="mr-2">
                            Select a file to upload
                            <v-icon right>mdi-file-plus-outline</v-icon>
                          </v-btn>
                        </div>
                        <v-dialog
                          persistent
                          v-model="dialog"
                          v-if="isDzi"
                          fullscreen
                          hide-overlay
                          transition="dialog-bottom-transition"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              class="mt-3"
                              small
                              dark
                              v-bind="attrs"
                              v-on="on"
                              @click="openPolygonsEditor()"
                            >
                              Edit link areas
                              <v-icon class="ml-1 text-subtitle-1"
                                >mdi-pencil</v-icon
                              >
                            </v-btn>
                          </template>
                          <v-card height="100%">
                            <v-toolbar dark color="primary">
                              <v-btn icon dark @click="dialog = false">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                              <v-toolbar-title>Edit link areas</v-toolbar-title>
                              <v-btn
                                dark
                                text
                                class="ml-2"
                                @click="addPolygon()"
                              >
                                <v-icon left>mdi-vector-square-plus</v-icon>New
                                polygon
                              </v-btn>
                              <v-btn
                                dark
                                text
                                :disabled="!selectedPolygon"
                                @click="deletePolygon()"
                              >
                                <v-icon left>mdi-vector-square-remove</v-icon
                                >Delete polygon
                              </v-btn>
                              <v-select
                                :items="poisParentsChildrenRecs"
                                v-model="selectedRecord"
                                item-value="id"
                                :label="
                                  selectedPolygon
                                    ? 'Linked record'
                                    : 'Select a polygon to link'
                                "
                                :disabled="!selectedPolygon"
                                dense
                                class="ml-4"
                                hide-details
                                :return-object="true"
                                @change="onChildRecordSelectChange($event)"
                              >
                                <template v-slot:selection="{ item }">
                                  {{ item.name }} -
                                  {{ recordTypeLabel(item) }}
                                </template>
                                <template v-slot:item="{ item }">
                                  {{ item.name }} -
                                  {{ recordTypeLabel(item) }}
                                </template>
                              </v-select>
                              <v-spacer></v-spacer>
                              <v-toolbar-items>
                                <v-btn dark text @click="savePolygons()"
                                  >Save</v-btn
                                >
                                <div class="point-data">
                                  x: {{ pointData.x }} <br />
                                  y: {{ pointData.y }}
                                </div>
                              </v-toolbar-items>
                            </v-toolbar>
                            <!-- <polygons-canvas :canvas-id="'canvas-one'" ref="childCanvas"></polygons-canvas> -->
                            <open-sea-dragon-viewer
                              @point="pointClicked"
                              ref="osdViewerRef"
                              :id="'osd-viewer'"
                              :options="{
                                sequenceMode: false,
                                defaultZoomLevel: 1,
                                minZoomLevel: 1,
                                maxZoomLevel: 5,
                                ajaxWithCredentials: false,
                                showNavigator: false,
                                showNavigationControl: false,
                                showReferenceStrip: false,
                                homeFillsViewer: true,
                                constrainDuringPan: true,
                                visibilityRatio: 1,
                                iOSDevice: true,
                                loadTilesWithAjax: true,
                                ajaxWithCredentials: true,
                                //ajaxHeaders: {
                                // Example of using the viewer-level ajaxHeaders option
                                // for providing an authentication token.
                                //  Authorization: 'Bearer ' + token
                                //},
                                animationTime: 0.5,
                                immediateRender: true
                              }"
                              :tile-sources="currentTileSources"
                              :polygonsData="polygonsData"
                              @selected="onSelection"
                              @deselected="onDeselection"
                              @delete="onDelete"
                            />
                          </v-card>
                        </v-dialog>
                        <v-img
                          :src="imageData"
                          max-height="400"
                          contain
                          class="grey darken-4 black--text align-end mt-3"
                        ></v-img>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                  <template
                    v-else-if="imageAssetTabActive === 'image-asset-tab-url'"
                  >
                    <v-card flat class="mx-auto pt-10">
                      <v-card-actions>
                        <v-text-field
                          v-model="editedItem.url"
                          label="URL"
                          @input="onUrlFieldChange"
                          clearable
                          @click:clear="clearUrl()"
                        ></v-text-field>
                      </v-card-actions>
                      <v-img
                        :src="imageData"
                        max-height="400"
                        contain
                        class="grey darken-4 black--text align-end"
                      ></v-img>
                    </v-card>
                  </template>
                  <template v-else>
                    <upload-dialog
                      :showDialog="uploadDialogVisible"
                      @done="uploadDialogOnDone"
                      @cancel="uploadDialogOnCancel"
                    ></upload-dialog>
                    <v-card flat class="mx-auto pt-5 pb-5">
                      <div
                        @drop.prevent="addFile"
                        @dragover.prevent
                        class="drop-area"
                      >
                        <span>Drop a file to upload</span>
                        <span>or</span>
                        <v-btn small @click="upload" class="mr-2">
                          Select a file to upload
                          <v-icon right>mdi-file-plus-outline</v-icon>
                        </v-btn>
                      </div>
                      <v-dialog
                        persistent
                        v-model="dialog"
                        v-if="isDzi"
                        fullscreen
                        hide-overlay
                        transition="dialog-bottom-transition"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            class="mt-3"
                            small
                            dark
                            v-bind="attrs"
                            v-on="on"
                            @click="openPolygonsEditor()"
                          >
                            Edit link areas
                            <v-icon class="ml-1 text-subtitle-1"
                              >mdi-pencil</v-icon
                            >
                          </v-btn>
                        </template>
                        <v-card height="100%">
                          <v-toolbar dark color="primary">
                            <v-btn icon dark @click="dialog = false">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Edit link areas</v-toolbar-title>
                            <v-btn dark text class="ml-2" @click="addPolygon()">
                              <v-icon left>mdi-vector-square-plus</v-icon>New
                              polygon
                            </v-btn>
                            <v-btn
                              dark
                              text
                              :disabled="!selectedPolygon"
                              @click="deletePolygon()"
                            >
                              <v-icon left>mdi-vector-square-remove</v-icon
                              >Delete polygon
                            </v-btn>
                            <v-select
                              v-if="selectedPolygon"
                              :items="$store.state.MediaStore.linkedPois"
                              v-model="selectedRecord"
                              item-value="id"
                              label="Linked record"
                              dense
                              hide-details
                              class="ml-4"
                              :return-object="true"
                              @change="onChildRecordSelectChange($event)"
                            >
                              <template v-slot:selection="{ item }">
                                {{ item.name }} -
                                {{ recordTypeLabel(item) }}
                              </template>
                              <template v-slot:item="{ item }">
                                {{ item.name }} -
                                {{ recordTypeLabel(item) }}
                              </template>
                            </v-select>
                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                              <v-btn dark text @click="savePolygons()"
                                >Save2</v-btn
                              >
                            </v-toolbar-items>
                          </v-toolbar>
                          <!-- <polygons-canvas :canvas-id="'canvas-one'" ref="childCanvas"></polygons-canvas> -->
                          <open-sea-dragon-viewer
                            @point="pointClicked"
                            ref="osdViewerRef"
                            :id="'osd-viewer'"
                            :options="{
                              defaultZoomLevel: 1,
                              minZoomLevel: 1,
                              maxZoomLevel: 5,
                              ajaxWithCredentials: false,
                              showNavigator: false,
                              showNavigationControl: false,
                              showReferenceStrip: false,
                              homeFillsViewer: true,
                              constrainDuringPan: true,
                              visibilityRatio: 1,
                              iOSDevice: true,
                              loadTilesWithAjax: true,
                              ajaxWithCredentials: true,
                              //ajaxHeaders: {
                              // Example of using the viewer-level ajaxHeaders option
                              // for providing an authentication token.
                              //  Authorization: 'Bearer ' + token
                              //},
                              animationTime: 0.5,
                              immediateRender: true
                            }"
                            :tile-sources="currentTileSources"
                            :polygonsData="polygonsData"
                            @selected="onSelection"
                            @deselected="onDeselection"
                            @delete="onDelete"
                          />
                        </v-card>
                      </v-dialog>
                      <v-img
                        :src="imageData"
                        max-height="400"
                        contain
                        class="grey darken-4 black--text align-end mt-3"
                      ></v-img>
                    </v-card>
                  </template>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  editedItem.mediaTypeId === enums.MediaType.poi_title ||
                    editedItem.mediaTypeId === enums.MediaType.project_title ||
                    editedItem.mediaTypeId ===
                      enums.MediaType.menu_item_title ||
                    editedItem.mediaTypeId ===
                      enums.MediaType.unity_language_config
                "
              >
                <v-col cols="12" sm="6" md="12">
                  <v-textarea
                    rows="6"
                    outlined
                    v-model="editedItem.textualContent"
                    label="Textual content"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  editedItem.mediaTypeId === enums.MediaType.description ||
                    editedItem.mediaTypeId ===
                      enums.MediaType.project_text_description
                "
              >
                <v-col cols="12" sm="6" md="12">
                  <editor
                    v-model="editedItem.textualContent"
                    :init="{
                      invalid_styles: {
                        table: 'height',
                        tr: 'width height',
                        th: 'width height',
                        td: 'width height'
                      },
                      height: 550,
                      menubar: true,
                      plugins: [
                        'advlist autolink lists link',
                        'searchreplace visualblocks',
                        'insertdatetime table paste code'
                      ],
                      table_default_attributes: {
                        border: '0'
                      },
                      table_default_styles: {
                        width: '100%'
                      },
                      menubar: false,
                      toolbar:
                        'undo redo | table | bold italic backcolor | \
               alignleft aligncenter alignright alignjustify | \
               bullist numlist outdent indent | removeformat | code'
                    }"
                  />
                </v-col>
              </v-row>
              <v-row
                v-if="
                  this.$store.state.PoiStore.poiContext === 'building' &&
                    editedItem.mediaTypeId === enums.MediaType.poi_image_dzi
                "
              >
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="order"
                    :hide-details="true"
                    label="Order"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  this.$store.state.PoiStore.poiContext === 'building' &&
                    editedItem.mediaTypeId === enums.MediaType.poi_image_dzi
                "
              >
                <v-col cols="12" sm="6" md="6">
                  <v-checkbox
                    :input-value="editedItem.mediaData.isCrossSection"
                    label="Cross section"
                    :hide-details="true"
                    @change="setIsCrossSection"
                  ></v-checkbox>
                </v-col>
                <v-col
                  v-if="editedItem.mediaData.isCrossSection"
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-text-field
                    :value="editedItem.mediaData.floorIndex"
                    type="number"
                    label="Floor index"
                    hint="Unique per building, e.g. -1, 0, 1, 2 ..."
                    persistent-hint
                    :error-messages="crossSectionFloorError"
                    @input="setFloorIndex"
                    @blur="checkCrossSectionFloorAvailability"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0" v-if="isSuperAdmin">
                <!--            <v-col cols="12" sm="6" md="3">-->
                <!--              <v-text-field label="Media Data" solo readonly></v-text-field>-->
                <!--            </v-col>-->
                <v-col cols="12" sm="6" md="12">
                  <v-card>
                    <v-card-title>Media Data</v-card-title>
                    <v-jsoneditor
                      v-model="editedItem.mediaData"
                      :plus="true"
                      height="300px"
                      @onChangeText="onJsonEditorChange"
                      :options="{ mode: 'text' }"
                    ></v-jsoneditor>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item :key="1">
            <v-container fluid class="pa-0 ma-0">
              <v-container fluid class="d-flex align-center pr-4 pl-2">
                <v-spacer></v-spacer>
                <v-text-field
                  :hide-details="true"
                  v-model="searchKeywords"
                  outlined
                  dense
                  label="Search"
                  style="max-width: 200px"
                >
                  <v-icon slot="append">mdi-magnify</v-icon>
                </v-text-field>
              </v-container>

              <div class="pa-4 pt-0">
                <div
                  v-for="m in $store.state.MediaManagerStore.media"
                  :key="m.id"
                  class="mb-2"
                >
                  <media-card-multi
                    :is-grid-view="false"
                    :media="m"
                    :hideActions="true"
                    :checked="isCheckedMedia(m.id)"
                    :showCheckbox="true"
                    @changeChecked="changeChecked(m.id)"
                  ></media-card-multi>
                </div>
              </div>
            </v-container>
          </v-tab-item>
        </v-tabs>
        <v-container v-else>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="editedItem.name"
                :hide-details="true"
                label="Name"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-select
                :items="getMediaTypes"
                v-model="editedItem.mediaTypeId"
                label="Media Type"
                item-text="label"
                item-value="value"
                :hide-details="true"
                :disabled="editedIndex !== -1"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <!-- <v-text-field
                v-model="editedItem.langId"
                label="Language ID"
                :hide-details="true"
              ></v-text-field> -->
              <v-select
                :items="langOptions"
                item-text="name"
                item-value="id"
                label="Language"
                outlined
                v-model="editedItem.langId"
                :menu-props="{ top: false, offsetY: true }"
                class="mx-0 mb-3"
                hide-details="auto"
              ></v-select>
            </v-col>
          </v-row>
          <v-row
            justify="space-around"
            v-if="
              editedItem.mediaTypeId === enums.MediaType.poi_image ||
                editedItem.mediaTypeId ===
                  enums.MediaType.project_title_image ||
                editedItem.mediaTypeId === enums.MediaType.poi_image_dzi ||
                editedItem.mediaTypeId === enums.MediaType.menu_item_image
            "
          >
            <v-col cols="12" sm="12" md="12">
              <template v-if="imageAssetTabActive === 'image-asset-tab-url'">
                <v-card flat class="mx-auto pt-10">
                  <v-card-actions>
                    <v-text-field
                      v-model="editedItem.url"
                      label="URL"
                      @input="onUrlFieldChange"
                      clearable
                      @click:clear="clearUrl()"
                    ></v-text-field>
                  </v-card-actions>
                  <v-img
                    :src="imageData"
                    max-height="400"
                    contain
                    class="grey darken-4 black--text align-end"
                  ></v-img>
                </v-card>
              </template>
              <template v-else>
                <upload-dialog
                  :showDialog="uploadDialogVisible"
                  @done="uploadDialogOnDone"
                  @cancel="uploadDialogOnCancel"
                ></upload-dialog>
                <v-card flat class="mx-auto pt-5 pb-5">
                  <div
                    @drop.prevent="addFile"
                    @dragover.prevent
                    class="drop-area"
                  >
                    <span>Drop a file to upload</span>
                    <span>or</span>
                    <v-btn small @click="upload" class="mr-2">
                      Select a file to upload
                      <v-icon right>mdi-file-plus-outline</v-icon>
                    </v-btn>
                  </div>
                  <v-dialog
                    persistent
                    v-model="dialog"
                    v-if="isDzi"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        class="mt-3 ml-1"
                        small
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="openPolygonsEditor()"
                      >
                        Edit link areas!!!
                        <v-icon class="ml-1 text-subtitle-1">mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn
                        color="primary"
                        class="mt-3"
                        small
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="openPolygonsEditorForPois()"
                      >
                        Edit link areas for pois!!!
                        <v-icon class="ml-1 text-subtitle-1">mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <v-card height="100%">
                      <v-toolbar dark color="primary" v-if="!shouldShowPois">
                        <v-btn icon dark @click="closeDialog">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{ linkAreasTitle }}</v-toolbar-title>
                        <v-select
                          :items="notLinkedAssets"
                          v-model="selectedAsset"
                          :label="
                            selectedAsset.name
                              ? selectedAsset.name
                              : `Linked Record`
                          "
                          dense
                          hide-details
                          class="ml-4"
                          :return-object="true"
                          @input="onChildRecordSelectChange(selectedAsset)"
                        >
                          <template v-slot:selection="{ item }">
                            {{ item.name }} -
                            {{ recordTypeLabel(item) }}
                          </template>
                          <template v-slot:item="{ item }">
                            {{ item.name }} -
                            {{ recordTypeLabel(item) }}
                          </template>
                        </v-select>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              dark
                              small
                              class="ml-2"
                              v-bind="attrs"
                              v-on="on"
                              @click="addPolygon()"
                            >
                              <v-icon>mdi-vector-square-plus</v-icon>
                            </v-btn>
                          </template>
                          <span>New polygon</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              dark
                              small
                              :disabled="!selectedPolygon"
                              v-bind="attrs"
                              v-on="on"
                              @click="deletePolygon()"
                            >
                              <v-icon>mdi-vector-square-remove</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete selected polygon</span>
                        </v-tooltip>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="align-center">
                          <v-btn
                            v-show="pointData"
                            dark
                            text
                            @click="writeCoordsToClipboard"
                            >x: {{ Math.round(pointData.x) }} y:
                            {{ Math.round(pointData.y) }}</v-btn
                          >
                          <v-btn dark text @click="savePolygons()">Save3</v-btn>
                        </v-toolbar-items>
                      </v-toolbar>

                      <v-toolbar dark color="primary" v-else>
                        <v-btn icon dark @click="closeDialog()">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Edit links for pois</v-toolbar-title>
                        <v-select
                          :items="$store.state.MediaStore.notLinkedPois"
                          v-model="selectedAsset"
                          item-value="id"
                          :label="
                            selectedAsset.name
                              ? selectedAsset.name
                              : `Linked Record`
                          "
                          dense
                          hide-details
                          class="ml-4"
                          :return-object="true"
                          @input="onChildRecordSelectChange(selectedAsset)"
                        >
                          <template v-slot:selection="{ item }">
                            {{ item.name }} 3
                            <!-- {{ item.community ? "community" : "masterplan" }} -->
                          </template>
                          <template v-slot:item="{ item }">
                            {{ item.name }} ,
                            <!-- {{ item.community ? "community" : "masterplan" }} -->
                          </template>
                        </v-select>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              dark
                              small
                              class="ml-2"
                              :disabled="!selectedAsset || !selectedAsset.id"
                              v-bind="attrs"
                              v-on="on"
                              @click="addPoi()"
                            >
                              <v-icon>mdi-map-marker-plus</v-icon>
                            </v-btn>
                          </template>
                          <span>Add poi at last clicked point</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              dark
                              small
                              :disabled="!selectedPoiMarker"
                              v-bind="attrs"
                              v-on="on"
                              @click="deletePoi()"
                            >
                              <v-icon>mdi-map-marker-remove</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete selected poi</span>
                        </v-tooltip>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                          <v-btn
                            v-show="pointData"
                            dark
                            text
                            @click="writeCoordsToClipboard"
                            >x: {{ Math.round(pointData.x) }} y:
                            {{ Math.round(pointData.y) }}</v-btn
                          >
                          <v-btn dark text @click="savePolygons()">Save</v-btn>
                        </v-toolbar-items>
                      </v-toolbar>
                      <div
                        style="
                          position: absolute;
                          color: rgb(0.05, 0.05, 0.05);
                          background-color: rgba(1, 1, 1, 0.75);
                          height: auto;
                          width: 300px;
                          transform: translate3d(12px, 12px, 0px);
                          z-index: 154;
                          border-radius: 20px;
                          padding: 6px;
                        "
                      >
                        <!-- Checkbox for affecting all polygons -->
                        <v-checkbox
                          v-model="affectAllPolygons"
                          label="Affect all polygons"
                          class="mt-0 pa-2"
                          hide-details
                        ></v-checkbox>
                        <div>
                          <!-- X Coordinate Input -->
                          <v-text-field
                            v-model="translation.x"
                            label="X Coordinate"
                            type="number"
                            class="mt-2 pa-2 pt-4"
                            dense
                            min="0"
                            placeholder="0"
                          />

                          <v-text-field
                            v-model="translation.y"
                            label="Y Coordinate"
                            type="number"
                            class="mt-2 pa-2"
                            dense
                            min="0"
                            placeholder="0"
                          />

                          <!-- Slider for scaling all polygons -->
                          <!-- Scale Slider and Input -->
                          <div class="d-flex align-center mt-2">
                            <v-slider
                              v-model="scaleValue"
                              :min="0.1"
                              :max="3"
                              step="0.01"
                              label="Scale"
                              class="pl-2"
                              hide-details
                            ></v-slider>

                            <!-- Input for precise scale value -->
                            <v-text-field
                              v-model="scaleValue"
                              type="number"
                              min="0.1"
                              max="3"
                              step="0.01"
                              class="ml-2"
                              label="Value"
                              dense
                              hide-details
                              @input="updateScaleValue"
                            ></v-text-field>
                          </div>
                        </div>
                      </div>

                      <!-- How each pin on this image shows in the Property
                           Navigator. Stored on the pin's own entry in
                           mediaData.pois, so it saves with the media item like
                           the pins themselves. Always shown in pin mode, one row
                           per pin; the pin selected on the canvas is
                           highlighted. -->
                      <div v-if="shouldShowPois" class="poi-display-panel">
                        <div class="text-subtitle-2 px-2 pt-1">
                          How pins show
                        </div>
                        <div
                          v-if="!pinsOnImage.length"
                          class="caption px-2 pb-1"
                        >
                          No pins on this image yet - pick a POI above, click
                          the image, then the add-pin button.
                        </div>
                        <div
                          v-for="pin in pinsOnImage"
                          :key="pin.id"
                          class="poi-display-row"
                          :class="{
                            'poi-display-row--selected':
                              pin === selectedPoiEntry
                          }"
                        >
                          <div class="d-flex align-center">
                            <span class="text-body-2 text-truncate mr-2">
                              {{ pin.name }}
                            </span>
                            <v-spacer></v-spacer>
                            <v-switch
                              :input-value="pinShowsAsLabel(pin)"
                              label="Label"
                              class="mt-0 pt-0"
                              hide-details
                              dense
                              @change="
                                setPinField(
                                  pin,
                                  'displayMode',
                                  $event ? 'label' : 'pin'
                                )
                              "
                            ></v-switch>
                          </div>
                          <v-text-field
                            :value="pin.label || ''"
                            :disabled="!pinShowsAsLabel(pin)"
                            :placeholder="pin.name"
                            label="Label text"
                            class="mt-3"
                            hide-details
                            dense
                            @input="setPinField(pin, 'label', $event)"
                            @blur="
                              setPinField(
                                pin,
                                'label',
                                (pin.label || '').trim()
                              )
                            "
                          ></v-text-field>
                        </div>
                        <div class="caption px-2 pt-1">
                          Empty label text uses the POI name. Saved with the
                          image: Save here, then Save on the media item.
                        </div>
                      </div>

                      <!-- <polygons-canvas :canvas-id="'canvas-one'" ref="childCanvas"></polygons-canvas> -->
                      <open-sea-dragon-viewer
                        @point="pointClicked"
                        ref="osdViewerRef"
                        :id="'osd-viewer'"
                        :options="{
                          defaultZoomLevel: 1,
                          minZoomLevel: 1,
                          maxZoomLevel: 5,
                          ajaxWithCredentials: false,
                          showNavigator: false,
                          showNavigationControl: false,
                          showReferenceStrip: false,
                          homeFillsViewer: true,
                          constrainDuringPan: true,
                          visibilityRatio: 1,
                          iOSDevice: true,
                          loadTilesWithAjax: true,
                          ajaxWithCredentials: true,
                          //ajaxHeaders: {
                          // Example of using the viewer-level ajaxHeaders option
                          // for providing an authentication token.
                          //  Authorization: 'Bearer ' + token
                          //},
                          animationTime: 0.5,
                          immediateRender: true
                        }"
                        :tile-sources="currentTileSources"
                        :polygonsData="getDrawingData"
                        :poisData="poisData"
                        :shouldShowPois="shouldShowPois"
                        :affect-all-polygons="affectAllPolygons"
                        :translation="translation"
                        :scale-value="scaleValue"
                        @selected="onSelection"
                        @deselected="onDeselection"
                        @delete="onDelete"
                        @poi-moved="onPoiMoved"
                      />
                    </v-card>
                  </v-dialog>

                  <v-img
                    :src="imageData"
                    max-height="400"
                    contain
                    class="grey darken-4 black--text align-end mt-3"
                  ></v-img>
                </v-card>
              </template>
            </v-col>
          </v-row>
          <v-row
            v-if="
              editedItem.mediaTypeId === enums.MediaType.poi_title ||
                editedItem.mediaTypeId === enums.MediaType.project_title ||
                editedItem.mediaTypeId === enums.MediaType.menu_item_title ||
                editedItem.mediaTypeId === enums.MediaType.unity_language_config
            "
          >
            <v-col cols="12" sm="6" md="12">
              <v-textarea
                rows="6"
                outlined
                v-model="editedItem.textualContent"
                label="Textual content"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row
            v-if="
              editedItem.mediaTypeId === enums.MediaType.description ||
                editedItem.mediaTypeId ===
                  enums.MediaType.project_text_description
            "
          >
            <v-col cols="12" sm="6" md="12">
              <editor
                v-model="editedItem.textualContent"
                :init="{
                  invalid_styles: {
                    table: 'height',
                    tr: 'width height',
                    th: 'width height',
                    td: 'width height'
                  },
                  height: 550,
                  menubar: true,
                  plugins: [
                    'advlist autolink lists link',
                    'searchreplace visualblocks',
                    'insertdatetime table paste code'
                  ],
                  table_default_attributes: {
                    border: '0'
                  },
                  table_default_styles: {
                    width: '100%'
                  },
                  menubar: false,
                  toolbar:
                    'undo redo | table | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | code'
                }"
              />
            </v-col>
          </v-row>
          <v-row
            v-if="
              this.$store.state.PoiStore.poiContext === 'building' &&
                editedItem.mediaTypeId === enums.MediaType.poi_image_dzi
            "
          >
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="editedItem.mediaData.order"
                :hide-details="true"
                label="Order"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              this.$store.state.PoiStore.poiContext === 'building' &&
                editedItem.mediaTypeId === enums.MediaType.poi_image_dzi
            "
          >
            <v-col cols="12" sm="6" md="6">
              <v-checkbox
                :input-value="editedItem.mediaData.isCrossSection"
                label="Cross section"
                :hide-details="true"
                @change="setIsCrossSection"
              ></v-checkbox>
            </v-col>
            <v-col
              v-if="editedItem.mediaData.isCrossSection"
              cols="12"
              sm="6"
              md="6"
            >
              <v-text-field
                :value="editedItem.mediaData.floorIndex"
                type="number"
                label="Floor index"
                hint="Unique per building, e.g. -1, 0, 1, 2 ..."
                persistent-hint
                :error-messages="crossSectionFloorError"
                @input="setFloorIndex"
                @blur="checkCrossSectionFloorAvailability"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-col v-if="isDzi" cols="3" sm="12" md="3">
            <v-row justify="center">
              <v-card>
                <v-card-title>Compass orientation</v-card-title>
                <div v-if="editedItem.mediaData.compassEnabled">
                  <compass
                    :initialDegs="editedItem.mediaData.compassAngle || 0"
                    @angleChange="compassAngleChange"
                  />
                </div>
                <v-btn
                  @click="toggleCompass"
                  :color="
                    editedItem.mediaData.compassEnabled ? 'danger' : 'primary'
                  "
                >
                  {{
                    editedItem.mediaData.compassEnabled
                      ? 'Disable compass'
                      : 'Enable compass'
                  }}?
                </v-btn>
                <div
                  style="margin-top: 12px"
                  v-if="editedItem.mediaData.compassEnabled === undefined"
                >
                  Upon enabling compass for the first time, we will save this
                  page immediatelly and close so we could persist change and
                  bootstrap compass logic
                </div>
              </v-card>
            </v-row>
          </v-col>
          <v-row class="mt-0" v-if="isSuperAdmin">
            <v-col cols="12" sm="6" md="3">
              <v-text-field label="Media Data" solo readonly></v-text-field>
            </v-col>
            <v-col cols="9" sm="6" md="9">
              <v-card>
                <v-card-title>Media Data</v-card-title>
                <v-jsoneditor
                  v-model="editedItem.mediaData"
                  :plus="true"
                  height="300px"
                  @onChangeText="onJsonEditorChange"
                  :options="{ mode: 'text' }"
                ></v-jsoneditor>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn
          v-if="editedIndex !== -1"
          color="#FF5252"
          small
          @click="deleteMedia"
          >Delete</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="darken-1" small @click="close">Cancel</v-btn>
        <v-btn color="blue darken-1" small @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MediaCardMulti from '../components/MediaCards/MediaCardMulti'
//import UploadDialog from '../components/UploadDialog'
import VJsoneditor from 'v-jsoneditor/src/index'
import Enums from '../helpers/Enums'
import { FilesGetMixin } from '../mixins/FilesGetMixin'
import UploadDialog from './UploadDialog'
import OpenSeadragonMixin from '../mixins/OpenSeadragonMixin'
import OpenSeaDragonViewer from '../components/Polygons/OpenSeadragonViewer'
import Editor from '@tinymce/tinymce-vue'
import { sleep } from '../../utils.js'
import Compass from '../components/Compass'
import PoiService from '@/services/PoiService'
import { mapState } from 'vuex'

export default {
  mixins: [FilesGetMixin, OpenSeadragonMixin],
  components: {
    UploadDialog,
    VJsoneditor,
    'open-sea-dragon-viewer': OpenSeaDragonViewer,
    editor: Editor,
    MediaCardMulti,
    Compass
  },
  computed: {
    pinsOnImage() {
      return Array.isArray(this.poisData) ? this.poisData : []
    },
    // The persisted mediaData.pois entry behind the pin selected on the
    // canvas (its raster carries the poi id in data.id).
    selectedPoiEntry() {
      const marker = this.selectedPoiMarker
      if (!marker || !marker.data || !Array.isArray(this.poisData)) return null
      return this.poisData.find(p => p.id === marker.data.id) || null
    },
    // Project-wide default (properties.showPoiAsText) that a pin without its
    // own displayMode falls back to in the Property Navigator.
    projectShowsPoisAsLabels() {
      const project = this.$store.state.ProjectStore.selectedProject
      const v =
        project && project.properties && project.properties.showPoiAsText
      return v === true || v === 1 || v === '1'
    },
    getDrawingData() {
      if (this.shouldShowPois) {
        return this.poisData
      } else {
        return this.polygonsData
      }
    },
    ...mapState('PoiStore', ['selectedPoi']),
    notLinkedAssets() {
      // return this.$store.state.MediaStore.notLinkedAssets
      let assets = this.$store.state.MediaStore.notLinkedAssets
      let formatedAssets = assets.map(function(e, index) {
        var obj = Object.assign({}, e)

        // Preserve `type` (parcel/building/apartment/masterplan) so the
        // linked-record dropdown can label each record correctly. Without it
        // recordTypeLabel() falls back to 'masterplan' for every entry.
        return {
          name: e.name,
          id: e.id,
          type: e.type,
          community: e.community,
          value: obj
        }
      })
      // sort array of assets in descending order
      let sortedAssets = this.sortAssetsInDescendingOrderPerName(formatedAssets)

      return sortedAssets
    },
    // Title reflects which record kinds this DZI actually links to
    // (e.g. "Edit link areas for parcels" or "... for buildings & masterplans").
    linkAreasTitle() {
      const assets = this.$store.state.MediaStore.notLinkedAssets || []
      const plural = {
        parcel: 'parcels',
        building: 'buildings',
        apartment: 'apartments',
        masterplan: 'masterplans',
        community: 'communities'
      }
      const kinds = [
        ...new Set(
          assets.map(a => plural[this.recordTypeLabel(a)] || 'records')
        )
      ]
      if (!kinds.length) return 'Edit link areas'
      return 'Edit link areas for ' + kinds.join(' & ')
    },
    langOptions() {
      let arr = []
      Object.entries(Enums.lang).forEach(([key, value]) => {
        if (this.projectLangs.includes(value.id)) {
          arr.push(value)
        }
      })
      return arr
    },
    projectLangs() {
      if (
        this.$store.state.ProjectStore.projectConfig &&
        this.$store.state.ProjectStore.projectConfig.length > 0
      ) {
        return this.$store.state.ProjectStore.projectConfig[
          this.$store.state.ProjectStore.projectConfig.length - 1
        ].mediaData.selectedLangs
      }
      return []
    },
    isCheckedMedia() {
      return id => {
        return this.checkedMedia.includes(id)
      }
    },
    isMediaSelected() {
      return id => {
        return this.selectedMedia === id
      }
    },
    isSuperAdmin() {
      return this.$store.state.UserStore.userRole[0] === 'super_admin'
    },
    getMediaTypes() {
      let arr = []
      for (var i = 0; i < this.$store.state.MediaStore.mediaTypes.length; i++) {
        let obj = {
          value: this.$store.state.MediaStore.mediaTypes[i].typeId,
          label: this.$t(
            'mediaTypes.' + this.$store.state.MediaStore.mediaTypes[i].name
          )
        }
        arr.push(obj)
      }
      if (this.$store.state.PoiStore.poiContext === 'apartment') {
        arr = arr.filter(el => el.value !== Enums.MediaType.poi_image_dzi)
      }
      return arr
    },
    formTitle() {
      return this.editedIndex === -1 ? 'Add Media Item ' : 'Edit Media Item'
    },
    imageAssetTabActive: {
      get: function() {
        let retVal = 'image-asset-tab-url'
        if (this.mediaAssetType === Enums.MediaAssetType.image_path) {
          retVal = 'image-asset-tab-file'
        }
        // if (this.editedItem.path && this.editedItem.path !== '') {
        //   retVal = 'image-asset-tab-file'
        // }
        // console.log('editedItem', this.editedItem, retVal)
        return retVal
      },
      set: function(newVal) {
        this.changeMediaAssetType(newVal)
      }
    },
    currentFile: {
      get: function() {
        return new File([this.editedItem.path], this.editedItem.path, [
          {
            type: `text/${this.editedItem.path.substring(
              this.editedItem.path.lastIndexOf('.') + 1,
              this.editedItem.path.length
            )}`
          }
        ])
      },
      set: function(newValue) {
        console.log(newValue)
      }
    }
    // imageData: {
    //   get: function() {
    //     let retVal = ''
    //     this.getImage(this.editedItem).then(r => {
    //       retVal = r
    //     })
    //     return retVal
    //   }
    // }
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
      default: false
    },
    editedItem: {
      type: Object,
      required: true,
      default: function() {
        return {
          name: 'New Media Item',
          mediaTypeId: 0,
          textualContent: '',
          mediaData: '',
          path: '',
          url: '',
          parentGalleryId: 0,
          poiId: 0,
          langId: 1
        }
      }
    },
    editedIndex: {
      type: Number,
      required: false,
      default: -1
    },
    poisParentsChildrenRecs: {
      type: Array,
      required: false
    }
  },

  created: async function() {
    this.displayed = this.showDialog
    this.$store.dispatch(
      'ProjectStore/getSelectedProjectSettings',
      this.$store.state.ProjectStore.selectedProject.id
    )
    await this.getData()
    this.mediaTypesEnum = Enums.MediaType
  },
  data() {
    return {
      pointData: { x: 0, y: 0 },
      searchParams: {
        langId: 0,
        search: null,
        mediaTypeId: 2,
        orderBy: 'updatedAt',
        orderDirection: 'desc'
      },
      selectedMedia: null,
      order: null,
      crossSectionFloorError: '',
      crossSectionFloorCheckTimer: null,
      isNewMedia: 0,
      searchKeywords: '',
      fileTypes: ['all', 'audio', 'video', 'image', 'data', 'text', 'gallery'],
      defaultItem: {
        name: 'New Media Item',
        mediaTypeId: 0,
        textualContent: '',
        mediaData: '',
        path: '',
        url: '',
        parentGalleryId: 0,
        poiId: 0,
        langId: 1
      },
      displayed: true,
      text: 'hello!',
      tabs: 2,
      tab: null,
      enums: Enums,
      imageAssetTab: 'image-asset-tab-file',
      imageData: '',
      uploadDialogVisible: false,
      mediaAssetType: Enums.MediaAssetType.image_path,
      isDzi: false,
      currentTileSources: null,
      dialog: false,
      token: null,
      selectedRecord: null,
      selectedPolygon: null,
      selectedPoiMarker: null,
      selectedAsset: { name: '', id: 0, value: {} },
      polygonsData: null,
      poisData: null,
      checkedMedia: [],
      linkedPois: [],
      shouldShowPois: false,
      affectAllPolygons: false, // Whether to affect all polygons
      translation: {
        x: 0, // X translation
        y: 0 // Y translation
      },
      scaleValue: 1 // Scale factor for all polygons
    }
  },
  watch: {
    '$store.state.MediaStore.notLinkedAssets'() {},
    searchParams: {
      deep: true,
      async handler() {
        await this.$store.dispatch(
          'MediaManagerStore/fetchMedia',
          this.searchParams
        )
      }
    },
    async '$store.state.MediaManagerStore.media'() {
      let currentContext = this.$store.state.BreadcrumbsStore.history.slice(
        -1
      )[0]
      if (currentContext) {
        currentContext.text === 'PROJECT'
          ? await this.$store.dispatch('PoiStore/setPoiContext', 'app')
          : await this.$store.dispatch(
              'PoiStore/setPoiContext',
              currentContext.text.toLowerCase
            )
        await this.$store.dispatch('PoiStore/fetchPois')
      } else {
        await this.$store.dispatch('PoiStore/setPoiContext', 'masterplans')
        await this.$store.dispatch('PoiStore/fetchPois')
      }
    },
    searchKeywords: function(val) {
      if (this.searchTimer !== null) {
        clearTimeout(this.searchTimer)
      }
      this.searchTimer = setTimeout(async () => {
        this.infiniteScrollDummyVisible = false
        await this.$store.dispatch('MediaManagerStore/resetMedia')
        await this.$store.dispatch('MediaManagerStore/resetPaging')
        this.searchParams = Object.assign({}, this.searchParams, {
          search: val
        })
      }, 500) // 1 sec delay
    },
    showDialog(newValue) {
      this.imageData = ''
      this.displayed = newValue
      this.selectedMedia = null
      this.checkedMedia = []
      this.isNewMedia = 0
      this.scaleValue = 1
      this.translation = { x: 0, y: 0 }
      this.affectAllPolygons = false
    },
    editedItem: function(newMedia, oldVal) {
      this.refreshEditor(newMedia)
      this.mediaAssetType = Enums.MediaAssetType.image_path
      if (newMedia.path && newMedia.path !== '') {
        this.mediaAssetType = Enums.MediaAssetType.image_path
      } else if (newMedia.url && newMedia.url !== '') {
        this.mediaAssetType = Enums.MediaAssetType.image_url
      }

      this.refreshImage(newMedia)
      this.isDzi = this.isMediaDzi(this.editedItem)
      if (this.isDzi) {
        this.currentTileSources = this.getOsdTileSources([this.editedItem])
        this.token = localStorage.apiCredentials
      }
    }
  },
  methods: {
    sortAssetsInDescendingOrderPerName(dataToSort) {
      let arrayOfObjectsToSort = dataToSort

      arrayOfObjectsToSort.sort((a, b) => {
        // Convert names to lowercase for case-insensitive sorting
        const nameA = a.name.toLowerCase()
        const nameB = b.name.toLowerCase()

        // Compare names and return the appropriate value for descending order
        if (nameA > nameB) {
          return -1
        } else if (nameA < nameB) {
          return 1
        } else {
          return 0
        }
      })
      return arrayOfObjectsToSort
    },
    closeDialog() {
      this.dialog = false
      // this.polygonsData = null
      // this.poisData = null
    },
    async toggleCompass() {
      if (this.editedItem.mediaData.compassEnabled === undefined) {
        this.editedItem.mediaData.compassEnabled = true
        this.editedItem.mediaData.compassAngle = 0

        await this.$store.dispatch('MediaStore/updateMedia', this.editedItem)
        // await this.$store.dispatch(
        //   'MediaManagerStore/fetchMedia',
        //   this.searchParams
        // )
        // await this.$store.dispatch('MediaManagerStore/resetMedia')
        // await this.$store.dispatch('MediaManagerStore/resetPaging')

        this.close()
        return
      } else {
        this.editedItem.mediaData.compassEnabled = !this.editedItem.mediaData
          .compassEnabled
      }

      await this.$store.dispatch('MediaStore/updateMedia', this.editedItem)
      await this.$store.dispatch(
        'MediaManagerStore/fetchMedia',
        this.searchParams
      )
      await this.$store.dispatch('MediaManagerStore/resetMedia')
      await this.$store.dispatch('MediaManagerStore/resetPaging')
    },
    compassAngleChange(degs) {
      if (this.editedItem.mediaData.compassEnabled) {
        this.editedItem.mediaData.compassAngle = degs
      }
    },
    pointClicked(pointData) {
      this.pointData = pointData
    },
    writeCoordsToClipboard() {
      const coords = {
        labelCoordinates: [
          Math.round(this.pointData.x),
          Math.round(this.pointData.y)
        ]
      }
      this.selectedPolygon.data.linkedRecord = {
        ...this.selectedPolygon.data.linkedRecord,
        ...coords
      }
      this.$store.dispatch(
        'NotificationStore/add',
        { type: 'success', message: `Coords stored` },
        { root: true }
      )
    },
    isMediaDzi(media) {
      // type with id 21 is the .dzi type of files
      if (media.mediaTypeId === 21) return true
    },
    // pointClicked(pointData) {
    //   this.pointData = pointData;
    // },
    // writeCoordsToClipboard() {
    //   const coords = {
    //     labelCoordinates: [
    //       Math.round(this.pointData.x),
    //       Math.round(this.pointData.y),
    //     ],
    //   };
    //   this.selectedPolygon.data.linkedRecord = {
    //     ...this.selectedPolygon.data.linkedRecord,
    //     ...coords,
    //   };
    //   this.$store.dispatch(
    //     "NotificationStore/add",
    //     { type: "success", message: `Coords stored` },
    //     { root: true }
    //   );
    // },
    async refreshEditor(newMedia) {
      if (
        (newMedia.mediaTypeId === this.enums.MediaType.description ||
          newMedia.mediaTypeId ===
            this.enums.MediaType.project_text_description) &&
        this.isNewMedia === 0
      ) {
        const mediaType =
          newMedia.mediaTypeId === this.enums.MediaType.description
            ? this.enums.MediaType.description
            : this.enums.MediaType.project_text_description
        newMedia.mediaTypeId = null
        await sleep(300)
        newMedia.mediaTypeId = mediaType
      }
    },
    resetOrder() {
      if (this.order) {
        this.order = null
      }
    },
    ensureMediaDataIsObject() {
      if (
        !this.editedItem.mediaData ||
        typeof this.editedItem.mediaData !== 'object'
      ) {
        this.$set(this.editedItem, 'mediaData', {})
      }
    },
    setIsCrossSection(value) {
      this.ensureMediaDataIsObject()
      this.$set(this.editedItem.mediaData, 'isCrossSection', value)
    },
    setFloorIndex(value) {
      this.ensureMediaDataIsObject()
      const parsed = value === '' || value === null ? '' : parseInt(value, 10)
      this.$set(
        this.editedItem.mediaData,
        'floorIndex',
        Number.isNaN(parsed) ? '' : parsed
      )
    },
    async validateCrossSectionFloor() {
      this.crossSectionFloorError = ''
      if (
        !this.editedItem.mediaData ||
        !this.editedItem.mediaData.isCrossSection
      ) {
        return true
      }
      const floor = this.editedItem.mediaData.floorIndex
      if (floor === undefined || floor === null || floor === '') {
        this.crossSectionFloorError = 'Floor index is required.'
        return false
      }
      const poiId = this.selectedPoi ? this.selectedPoi.id : 0
      const excludeMediaId = this.editedIndex > -1 ? this.editedItem.id : null
      const resp = await PoiService.checkCrossSectionFloorAvailability(
        poiId,
        floor,
        excludeMediaId
      )
      const available = resp.data.available
      if (!available) {
        this.crossSectionFloorError = `A cross section for floor ${floor} already exists on this building.`
      }
      return available
    },
    checkCrossSectionFloorAvailability() {
      if (this.crossSectionFloorCheckTimer) {
        clearTimeout(this.crossSectionFloorCheckTimer)
      }
      this.crossSectionFloorCheckTimer = setTimeout(() => {
        this.validateCrossSectionFloor()
      }, 300)
    },
    async getData() {
      await this.$store.dispatch(
        'MediaManagerStore/fetchMedia',
        this.searchParams
      )
    },
    setSelectedMedia(id) {
      if (this.selectedMedia !== id) {
        this.selectedMedia = id
      } else {
        this.selectedMedia = null
      }
    },
    changeChecked(id) {
      if (this.checkedMedia.includes(id)) {
        for (var i = 0; i < this.checkedMedia.length; i++) {
          if (this.checkedMedia[i] === id) {
            this.checkedMedia.splice(i, 1)
          }
        }
      } else if (!this.checkedMedia.includes(id)) {
        this.checkedMedia.push(id)
      }
    },
    clearUrl() {
      setTimeout(() => {
        this.editedItem.url = ''
      }, 1)
    },
    async deleteMedia() {
      await this.$confirm({
        title: 'Confirm delete',
        text: 'Are you sure?',
        acceptText: 'DELETE',
        cancelText: 'CANCEL'
      })
      await this.$store.dispatch('MediaStore/deleteMedia', this.editedItem.id)
      this.close()
    },
    addFile(files) {
      let fileList = files.dataTransfer.files
      if (
        fileList === null ||
        typeof fileList === 'undefined' ||
        !fileList.length
      ) {
        return
      }
      const formData = new FormData()
      for (let i = 0; i < fileList.length; i++) {
        formData.append(`file${i}`, fileList[i], fileList[i].name)
      }
      this.$store
        .dispatch('MediaStore/uploadFiles', {
          files: formData
        })
        .then(res => {
          this.uploadDialogOnDone(res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    close() {
      this.displayed = false
      this.shouldShowPois = false
      this.selectedPolygon = null
      this.$emit('close')
      // setTimeout(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem)
      //   this.editedIndex = -1
      // }, 300)
    },
    async save() {
      this.$store.dispatch('MediaStore/resetLinkedPois')
      this.$store.dispatch('MediaStore/resetNotLinkedPois')
      this.$store.dispatch('MediaStore/resetNotLinkedAssetsForDzi')
      if (this.qweData) {
        this.editedItem.mediaData.polygons = this.qweData
      }
      if (
        this.editedItem.mediaData &&
        this.editedItem.mediaData.isCrossSection &&
        !(await this.validateCrossSectionFloor())
      ) {
        await this.$confirm({
          title: 'Cannot save cross section',
          text: this.crossSectionFloorError,
          acceptText: 'OK'
        })
        return
      }
      if (this.isNewMedia === 1) {
        if (this.checkedMedia.length > 0) {
          let arr = this.$store.state.MediaManagerStore.media.filter(m =>
            this.checkedMedia.includes(m.id)
          )
          if (this.$store.state.PoiStore.selectedPoi) {
            for (let i = 0; i < arr.length; i++) {
              arr[i].poiId = this.$store.state.PoiStore.selectedPoi.id
            }
          }
          await this.$store.dispatch('MediaManagerStore/linkMedia', arr)
          this.close()
        }
        return
      }

      if (this.mediaAssetType === Enums.MediaAssetType.image_url) {
        this.editedItem.path = ''
      } else {
        this.editedItem.url = ''
      }

      try {
        if (this.editedIndex > -1) {
          let res = await this.$store.dispatch(
            'MediaStore/updateMedia',
            this.editedItem
          )
          let searchParams = {
            langId: 0,
            search: null,
            mediaTypeId: 2
          }
        } else {
          this.editedItem.order = this.order
          let res = await this.$store.dispatch(
            'MediaStore/createMedia',
            this.editedItem
          )
        }
      } catch (e) {
        await this.$confirm({
          title: 'Could not save media item',
          text:
            (e.response && e.response.data && e.response.data.message) ||
            e.message ||
            'An unknown error occurred.',
          acceptText: 'OK'
        })
        return
      }

      //this.$store.dispatch('MediaStore/fetchMedia')
      this.close()
    },
    upload() {
      this.uploadDialogVisible = true
    },
    onJsonEditorChange(newJson) {
      //this.editedItem.mediaData = newJson
    },
    uploadDialogOnDone(newValue) {
      this.uploadDialogVisible = false
      if (
        newValue.data &&
        Array.isArray(newValue.data) &&
        newValue.data.length > 0
      ) {
        if (newValue.data.length > 1) {
          console.warn('Uploaded more than one file, not implemented yet :-(')
        }
        this.editedItem.name = newValue.data[0].name
        this.editedItem.path = newValue.data[0].tempName
        this.getUpload(this.editedItem.path).then(r => {
          this.imageData = r
        })
      }
    },
    uploadDialogOnCancel() {
      this.$store.dispatch('MediaStore/resetLinkedPois')
      this.$store.dispatch('MediaStore/resetNotLinkedPois')
      this.$store.dispatch('MediaStore/resetNotLinkedAssetsForDzi')
      this.selectedPolygon = null
      this.uploadDialogVisible = false
    },
    changeMediaAssetType(newVal) {
      if (newVal === 'image-asset-tab-url') {
        this.mediaAssetType = Enums.MediaAssetType.image_url
      } else if (newVal === 'image-asset-tab-file') {
        this.mediaAssetType = Enums.MediaAssetType.image_path
      }
      this.refreshImage(this.editedItem)
    },
    refreshImage(newMedia) {
      if (
        this.mediaAssetType === Enums.MediaAssetType.image_path &&
        newMedia.path
      ) {
        this.getFile(newMedia).then(r => {
          if (
            [
              Enums.MediaType.menu_item_image,
              Enums.MediaType.project_title_image,
              Enums.MediaType.poi_image,
              Enums.MediaType.poi_image_dzi
            ].includes(newMedia.mediaTypeId)
          ) {
            this.imageData = r
          }
        })
      } else {
        this.imageData = ''
      }
      if (
        this.mediaAssetType === Enums.MediaAssetType.image_url &&
        newMedia.url
      ) {
        this.imageData = newMedia.url
      } else {
        this.imageData = ''
      }
    },
    onUrlFieldChange(newValue) {
      this.refreshImage(this.editedItem)
    },
    hasProcessedDziTiles() {
      return !!(
        this.editedItem.mediaData &&
        this.editedItem.mediaData.width &&
        this.editedItem.mediaData.height &&
        this.editedItem.mediaData.tileWidth &&
        this.editedItem.mediaData.tileHeight
      )
    },
    async openPolygonsEditor() {
      if (this.editedIndex === -1 || !this.hasProcessedDziTiles()) {
        this.dialog = false
        await this.$confirm({
          title: 'This image has no processed tiles',
          text:
            'This DZI image has not finished processing (missing tile data), so there is nothing to draw on. Delete it and re-upload the file, then save again.',
          acceptText: 'OK'
        })
        return
      }
      let self = this
      this.dialog = true
      // this.poisData = null
      this.shouldShowPois = false
      // HACK - to make sure refs are instantiated
      //
      if (
        Object.prototype.hasOwnProperty.call(
          self.editedItem.mediaData,
          'polygons'
        )
      ) {
        // self.$refs['osdViewerRef'].importFromJSON(
        //   self.editedItem.mediaData['polygons']
        // )
        self.polygonsData = self.editedItem.mediaData['polygons']
      } else {
        self.polygonsData = []
      }
    },
    async openPolygonsEditorForPois() {
      if (this.editedIndex === -1 || !this.hasProcessedDziTiles()) {
        this.dialog = false
        await this.$confirm({
          title: 'This image has no processed tiles',
          text:
            'This DZI image has not finished processing (missing tile data), so there is nothing to draw on. Delete it and re-upload the file, then save again.',
          acceptText: 'OK'
        })
        return
      }
      this.shouldShowPois = true
      this.qweData = this.editedItem.mediaData.polygons
      // this.polygonsData = null
      let self = this
      this.dialog = true
      // HACK - to make sure refs are instantiated
      //
      if (
        Object.prototype.hasOwnProperty.call(self.editedItem.mediaData, 'pois')
      ) {
        // self.$refs['osdViewerRef'].importFromJSON(
        //   self.editedItem.mediaData['polygons']
        // )
        self.poisData = self.editedItem.mediaData['pois']
      } else {
        self.poisData = []
      }
      if (this.$refs['osdViewerRef']) {
        this.$refs['osdViewerRef'].insertMarkersForPois()
      }
    },
    savePolygons() {
      let filteredItems = this.$refs['osdViewerRef'].removeImagesFromProject()
      let data = this.$refs['osdViewerRef'].exportToJSON()
      if (this.editedItem.mediaData['polygons'] !== undefined) {
        this.editedItem.mediaData['polygons'] = data
      } else {
        this.editedItem.mediaData = Object.assign(this.editedItem.mediaData, {
          polygons: data
        })
      }
      this.dialog = false
      this.polygonsData = null
      this.poisData = null
    },
    // Places a new poi marker at the last-clicked point, using whichever
    // record is currently picked in the "Linked Record" dropdown. Persists it
    // immediately and redraws markers, without closing the dialog — so
    // several pois can be added in one session (previously this only ran as
    // a side effect of Save, which also closed the whole dialog after just
    // one poi).
    addPoi() {
      if (!this.selectedAsset || !this.selectedAsset.id) return

      const dataPoi = {
        id: this.selectedAsset.id,
        type: 'poi',
        poiCoordinates: [
          Math.round(this.pointData.x),
          Math.round(this.pointData.y)
        ],
        name: this.selectedAsset.name
      }

      if (Array.isArray(this.editedItem.mediaData.pois)) {
        this.editedItem.mediaData.pois = [
          ...this.editedItem.mediaData.pois,
          dataPoi
        ]
      } else {
        this.editedItem.mediaData = Object.assign(this.editedItem.mediaData, {
          pois: [dataPoi]
        })
      }
      this.poisData = this.editedItem.mediaData.pois

      this.$store.dispatch(
        'MediaStore/removeNotLinkedPoi',
        this.selectedAsset.id
      )
      this.$store.dispatch('MediaStore/saveLinkedPoi', this.selectedAsset)

      // Clear the pick so the dropdown doesn't keep showing an already-placed
      // record. Redrawing the canvas is handled by the viewer's own poisData
      // watcher reacting to the assignment above — calling
      // insertMarkersForPois() imperatively here (via $refs, immediately
      // after the assignment) used to race Vue's async prop propagation and
      // read the stale list, wiping every marker instead of adding one.
      this.selectedAsset = { name: '', id: 0, value: {} }
    },
    // Deletes the poi marker currently selected on the canvas: removes it
    // from the canvas, drops its entry from the persisted list, and frees the
    // underlying record so it can be linked again elsewhere.
    deletePoi() {
      if (!this.$refs['osdViewerRef']) return
      const deleted = this.$refs['osdViewerRef'].deleteSelectedPoi()
      if (!deleted) return

      if (Array.isArray(this.editedItem.mediaData.pois)) {
        this.editedItem.mediaData.pois = this.editedItem.mediaData.pois.filter(
          p => p.id !== deleted.id
        )
        this.poisData = this.editedItem.mediaData.pois
      }

      this.$store.dispatch('MediaStore/removeLinkedPoi', deleted.id)
      this.$store.dispatch('MediaStore/saveNotLinkedPois', [
        { id: deleted.id, name: deleted.name }
      ])
      this.selectedPoiMarker = null
    },
    // A poi marker was dragged to a new spot on the canvas — update its
    // persisted coordinates to match, or the drag wouldn't actually stick
    // (poi entries aren't re-derived from canvas state on save the way
    // polygon shapes are).
    // A pin without its own displayMode falls back to the project default.
    pinShowsAsLabel(pin) {
      if (pin.displayMode === 'label') return true
      if (pin.displayMode === 'pin') return false
      return this.projectShowsPoisAsLabels
    },
    // Mutates the pin entry in place instead of replacing the pois array: a
    // new array would trip the viewer's poisData watcher, which redraws every
    // marker and drops the canvas selection mid-edit. editedItem.mediaData.pois
    // is this same array, so the change is saved with the media item. Label
    // text is kept as typed (trimming per keystroke would eat the space
    // between words) and trimmed on blur; blank removes the key.
    setPinField(pin, key, value) {
      const blank =
        value === null ||
        value === undefined ||
        (typeof value === 'string' && !value.trim())
      if (blank) {
        this.$delete(pin, key)
      } else {
        this.$set(pin, key, value)
      }
    },
    onPoiMoved({ id, poiCoordinates }) {
      if (!Array.isArray(this.editedItem.mediaData.pois)) return
      this.editedItem.mediaData.pois = this.editedItem.mediaData.pois.map(p =>
        p.id === id ? { ...p, poiCoordinates } : p
      )
      this.poisData = this.editedItem.mediaData.pois
    },
    onSelection(value) {
      if (value.data.type === 'poi') {
        this.selectedPoiMarker = value
        this.selectedAsset.name = value.data.name
      } else {
        this.selectedPolygon = value
        this.selectedPoiMarker = null
        this.selectedAsset.name = value.data.name
        this.selectedRecord = value.data.linkedRecord
      }
    },
    onDeselection() {
      this.selectedRecord = null
      this.selectedPolygon = null
      this.selectedPoiMarker = null
      // this.selectedAsset = { name: '', id: 0, value: {} }
    },
    onDelete() {
      this.selectedPolygon = null
      this.selectedPoiMarker = null
    },
    async onChildRecordSelectChange(selectedItem) {
      const { value } = await selectedItem

      if (value !== undefined) {
        this.selectedRecord = value
      } else {
        this.selectedRecord = selectedItem
      }

      if (!this.selectedPolygon) {
        // this.selectedRecord = value

        const coords = {
          poiCoordinates: [
            Math.round(this.pointData.x),
            Math.round(this.pointData.y)
          ]
        }
        let data = {
          id: selectedItem.id,
          type: 'poi',
          ...coords,
          name: selectedItem.name
        }
        // if (this.editedItem.mediaData['pois'] === undefined) {
        //   this.editedItem.mediaData['pois'] = [
        //     ...this.editedItem.mediaData['pois'],
        //     data
        //   ]
        // } else {
        //   this.editedItem.mediaData = Object.assign(this.editedItem.mediaData, {
        //     pois: [data]
        //   })
        // }

        // this.$store.dispatch('MediaStore/removeNotLinkedPoi', selectedItem.id)
        // this.$store.dispatch('MediaStore/saveLinkedPoi', selectedItem)
        // data = {
        //   id: value.id,
        //   from: 'toLinked',
        //   notLinkedPois: this.$store.state.MediaStore.notLinkedPois,
        //   linkedPois: this.$store.state.MediaStore.linkedPois
        // }
        // this.$store.dispatch('MediaStore/transferPoi', data)
        // this.$refs['osdViewerRef'].insertMarkersForPois()
      } else {
        this.$store.dispatch('MediaStore/removeNotLinkedAsset', value.id)
        this.$store.dispatch('MediaStore/removeLinkedPoi', value.id)
        let self = this
        this.selectedRecord = value
        this.selectedPolygon.data.linkedRecord = {
          id: self.selectedRecord.id,
          type: self.selectedRecord.type
        }
      }
    },
    updateScaleValue() {
      this.scaleValue = Math.round(this.scaleValue * 100) / 100
    },
    // Show the record's real type (parcel/building/apartment/masterplan) in the
    // linked-record dropdown; only masterplans carry the community distinction.
    recordTypeLabel(item) {
      if (!item) return ''
      if (item.type === 'masterplan' && item.community) return 'community'
      return item.type || 'masterplan'
    },
    addPolygon() {
      if (this.$refs['osdViewerRef']) {
        this.$refs['osdViewerRef'].createPaths()
      }
    },
    deletePolygon() {
      if (this.$refs['osdViewerRef']) {
        this.$refs['osdViewerRef'].deleteSelectedPolygon()
      }
    }
  },
  beforeMount: async function() {
    await this.$store.dispatch('MediaManagerStore/resetMedia')
    await this.$store.dispatch('MediaManagerStore/resetPaging')
  },
  beforeDestroy: async function() {
    await this.$store.dispatch('MediaManagerStore/resetMedia')
    await this.$store.dispatch('MediaManagerStore/resetPaging')
  }
}
</script>
<style media="screen">
/* Hide the spinner arrows on number inputs */
.v-input__control input[type='number']::-webkit-outer-spin-button,
.v-input__control input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.v-input__control input[type='number'] {
  -moz-appearance: textfield;
}

/* Same floating look as the transform panel at top-left, on the other side. */
.poi-display-panel {
  position: absolute;
  top: 76px;
  right: 12px;
  width: 300px;
  max-height: calc(100% - 100px);
  overflow-y: auto;
  z-index: 200;
  padding: 6px;
  border-radius: 20px;
  background-color: rgba(1, 1, 1, 0.75);
}

.poi-display-row {
  margin: 4px 0;
  padding: 6px 8px;
  border-radius: 12px;
}

.poi-display-row--selected {
  background-color: rgba(255, 255, 255, 0.12);
}

.drop-area {
  width: 100%;
  border: 4px dashed #ffffff;
  box-sizing: border-box;
  margin-top: 20px;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
